<template>
  <div class="ReportIssues">
    <span class="exclamation v-tooltip" @click="isFormVisible = !isFormVisible">
      <span class="v-tooltiptext">
        Are you having trouble with the survey? Click here
      </span>
      <i class="fa fa-exclamation-triangle"></i>
    </span>
    <form @submit.prevent="handleSubmit" v-if="isFormVisible">
      <div class="title">
        Are you having trouble with the survey? Please explain.
      </div>
      <textarea v-model="message"></textarea>
      <div class="flex">
        <button type="button" @click.prevent="isFormVisible = false">Cancel</button>
        <input type="submit" :value="loading ? 'Sending...' : 'Send'" :disabled="loading || message === ''"/>
      </div>
    </form>
  </div>
</template>

<script>

import config from "../../../../config/config.json";
import axios from "axios";
import swal from "sweetalert";

export default {
  props: {
    survey: String,
    treatment: String,
  },
  data() {
    return {
      isFormVisible: false,
      message: '',
      loading: false,
    }
  },
  computed: {},
  mounted() {
  },
  watch: {},
  methods: {
    handleShowForm() {
      this.isFormVisible = true;
    },
    handleHideForm() {
      this.isFormVisible = false;
    },
    handleSubmit() {
      this.loading = true;
      axios.post(`${config.dashboard.domain}/api/report-issue`, {
        survey: this.survey,
        server: config.server.id,
        treatment: this.treatment,
        message: this.message,
      })
        .then(response => {
          this.handleHideForm();
          this.message = '';
          swal({
            text: `Your report has been sent.`,
            icon: "success",
          });
        })
        .catch(e => {
          console.error({ e });
        })
        .finally(() => {
          this.loading = false;
        })
    },
  },
  components: {}
}
</script>

<style lang="scss" scoped>
.ReportIssues {
  position: fixed;
  bottom: 50px;
  left: 10px;
  z-index: 1;

  .exclamation {
    position: absolute;
    font-size: 30px;
    color: orange;
    cursor: pointer;
  }

  form {
    position: absolute;
    background: white;
    border: 1px solid #999;
    min-width: 350px;
    min-height: 100px;
    padding: 10px;
    left: 0;
    bottom: -40px;

    .title {
      font-weight: bold;
      font-size: 15px;
      padding-bottom: 10px;
    }

    textarea {
      width: 100%;
      border: 1px solid #bbb;
    }

    input, button {
      width: 50%;
      border-radius: 3px;
      border: 1px solid #888;
    }

    input {
      margin-left: 5px;
      background: #005eb8;
      border-color: #002e88;
      color: white;
    }

    button {
      margin-right: 5px;
    }
  }
}

/* Tooltip text */
.v-tooltip .v-tooltiptext {
  visibility: hidden;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  font-size: 13px;

  /* Position the tooltip text - see examples below! */
  position: absolute;

  bottom: 100%;
  left: 70px;

  width: 140px;
  margin-left: -70px; /* Use half of the width (120/2 = 60), to center the tooltip */
}

/* Show the tooltip text when you mouse over the tooltip container */
.v-tooltip:hover .v-tooltiptext {
  visibility: visible;
}

.flex {
  display: flex;
}
</style>
